import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TmDeliveryTourService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/tm-delivery-tours', params);
    }

    store(body: any) {
        return super.post(`/tm-delivery-tours`, body);
    }

    edit(tmTransporterId: number) {
        return super.get(`/tm-delivery-tours/${tmTransporterId}/edit`);
    }

    update(tmTransporterId: number, body: any) {
        return super.put(`/tm-delivery-tours/${tmTransporterId}`, body);
    }

    destroy(tmTransporterId: number) {
        return super.delete(`/tm-delivery-tours/${tmTransporterId}`);
    }

    select(params: any) {
        return super.get('/tm-delivery-tours/select', params);
    }
}
